import { Element } from '@/components/Atoms/Element/Element';
import classNames from '@/utils/classNames';
import type { ComponentProps, HTMLAttributes } from 'react';
import type { FCC } from 'react-fc';

/**
 * A component for a standard paragraph of text with correct line-heights etc.
 * By default, this is Crescent large size, since that's the most comfortable reading size for a paragraph.
 */
export const P: FCC<HTMLAttributes<HTMLParagraphElement> & {
  size?: 'small' | 'standard' | 'large' | 'xlarge';
  bold?: boolean;
  as?: ComponentProps<typeof Element>['as'];
}> = ({
  className,
  children,
  size = 'large',
  bold = false,
  as = 'p',
  ...rest
}) => {
  let tClassName = 'cds-t-body';
  if (size === 'xlarge') {
    tClassName = 'cds-t-body-xlarge';
  } else if (size !== 'standard') {
    tClassName += `-${size}`;
  }
  return <Element as={as} className={classNames(tClassName, {
    [`${tClassName}--b`]: bold && size !== 'xlarge'
  }, className)} {...rest}>
            {children}
        </Element>;
};